document.addEventListener('DOMContentLoaded', () => {
  // Mobile Menu Toggle
  const trigger = document.getElementById('MobileMenuTrigger');
  const menu = document.getElementById('MobileMenu');
  const close = document.getElementById('MobileMenuClose');
  const overlay = document.getElementById('MobileMenuOverlay');

  function toggleMenu() {
    if (!menu) return;
    const isOpen = !menu.classList.contains('-translate-x-full');
    if (isOpen) {
      menu.classList.add('-translate-x-full');
      if (overlay) overlay.classList.add('hidden');
    } else {
      menu.classList.remove('-translate-x-full');
      if (overlay) overlay.classList.remove('hidden');
    }
  }

  if (trigger) trigger.addEventListener('click', toggleMenu);
  if (close) close.addEventListener('click', toggleMenu);
  if (overlay) overlay.addEventListener('click', toggleMenu);

  // Product Gallery Image Switcher
  const mainImage = document.getElementById('ProductMainImage');
  const thumbnails = document.querySelectorAll('[data-thumbnail]');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const newSrc = this.dataset.src;
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
      }
    });
  });
});